import HeroAvatar from "/app/src/components/HeroUi/Avatar";
import { useAuthState } from "/app/src/contexts/authentication";
import { NavLink } from "react-router-dom";

/**
 *
 * @returns Avatar
 */
export default function Avatar() {
  const { user } = useAuthState();

  const firstLetter = user?.username.charAt(0).toUpperCase();

  return (
    <div className="flex items-center justify-center">
      <NavLink to={`/users/${user?.id}`}>
        <HeroAvatar radius="full" name={firstLetter} color="primary" />
      </NavLink>
    </div>
  );
}
